var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseCircleBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#303030"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.705 12.0001L16.35 8.35513C16.4319 8.25948 16.4747 8.13644 16.4698 8.0106C16.465 7.88477 16.4128 7.7654 16.3238 7.67635C16.2347 7.5873 16.1153 7.53514 15.9895 7.53027C15.8637 7.52541 15.7406 7.56822 15.645 7.65013L12 11.2951L8.35499 7.64513C8.25934 7.56322 8.1363 7.52041 8.01046 7.52528C7.88462 7.53014 7.76525 7.5823 7.67621 7.67135C7.58716 7.7604 7.53499 7.87977 7.53013 8.0056C7.52527 8.13144 7.56807 8.25448 7.64999 8.35013L11.295 12.0001L7.64499 15.6451C7.59265 15.69 7.55014 15.7451 7.52012 15.8071C7.49011 15.8692 7.47325 15.9367 7.47059 16.0056C7.46793 16.0745 7.47953 16.1431 7.50467 16.2073C7.52981 16.2715 7.56793 16.3297 7.61666 16.3785C7.66539 16.4272 7.72366 16.4653 7.78783 16.4904C7.85199 16.5156 7.92065 16.5272 7.98951 16.5245C8.05837 16.5219 8.12594 16.505 8.18797 16.475C8.25 16.445 8.30516 16.4025 8.34999 16.3501L12 12.7051L15.645 16.3501C15.7406 16.432 15.8637 16.4748 15.9895 16.47C16.1153 16.4651 16.2347 16.413 16.3238 16.3239C16.4128 16.2349 16.465 16.1155 16.4698 15.9897C16.4747 15.8638 16.4319 15.7408 16.35 15.6451L12.705 12.0001Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircleBtn);
export default __webpack_public_path__ + "static/media/close-circle-btn.f25a0c416930d77cbcbbe0c823782019.svg";
export { ForwardRef as ReactComponent };